import { TRIAD_PROXY_ROUTE } from 'app-requests/apiConstants';
import { LeadSubmitBatchId } from 'types';
import { triadSuperFetch } from 'utils/superFetch';

/**
 * Gets a new batch id for the current user.
 */
export async function getNewLeadSubmitBatchId(): Promise<LeadSubmitBatchId> {
  return triadSuperFetch<{ batchId: LeadSubmitBatchId }>(
    `${TRIAD_PROXY_ROUTE}/getNewLeadSubmitBatch`,
    {
      method: 'GET',
      timeout: 3000,
      retry: {
        maxAttempts: 3,
        waitTimeBetweenFails: 2000,
      },
      cache: {
        type: 'memory',
        key: 'newLeadSubmitBatchId',
      },
    }
  ).then(([error, response]) => {
    if (error || !response.batchId) {
      return '' as LeadSubmitBatchId;
    }
    return response.batchId;
  });
}
